import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import CardSkeletonLoader from './skeleton_loader';

const PricingSkeletonLoaderGroup = ({ isLoading }) => {
    if (!isLoading) return null;

    return (
        <Container>
            <Row>
                {[...Array(4)].map((_, index) => (
                    <Col key={index} md={3}>
                        <CardSkeletonLoader />
                    </Col>
                ))}
            </Row>
        </Container>    
    );
};

export default PricingSkeletonLoaderGroup;
